'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n  padding: ', ';\n\n  ', '\n'], ['\n  ', '\n  padding: ', ';\n\n  ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = require('../../config.js');

var _mixins = require('../../mixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.$hasTopMargin || props.$hasBottomMargin ? (0, _mixins.ClearFix)() : '';
}, function (props) {
  return props.$hasHorizontalPadding ? '0' : '0';
}, (0, _mixins.WysiwygStyles)({
  hasBottomMargin: function hasBottomMargin(props) {
    return props.$hasBottomMargin;
  },
  hasTopMargin: function hasTopMargin(props) {
    return props.$hasTopMargin;
  },
  baseFontSize: _config.typography.baseFontSize,
  fontSize: '16px'
}));

Wrapper.displayName = 'Wrapper';

var TextArea = function TextArea(_ref) {
  var _ref$hasBottomMargin = _ref.hasBottomMargin,
      hasBottomMargin = _ref$hasBottomMargin === undefined ? true : _ref$hasBottomMargin,
      _ref$hasTopMargin = _ref.hasTopMargin,
      hasTopMargin = _ref$hasTopMargin === undefined ? true : _ref$hasTopMargin,
      htmlString = _ref.htmlString,
      _ref$hasHorizontalPad = _ref.hasHorizontalPadding,
      hasHorizontalPadding = _ref$hasHorizontalPad === undefined ? true : _ref$hasHorizontalPad;
  return _react2.default.createElement(Wrapper, {
    $hasBottomMargin: hasBottomMargin,
    $hasTopMargin: hasTopMargin,
    $hasHorizontalPadding: hasHorizontalPadding,
    dangerouslySetInnerHTML: {
      __html: htmlString
    }
  });
};

TextArea.propTypes = {
  /** Whether or not a 30px bottom margin is applied. */
  hasBottomMargin: _propTypes2.default.bool,
  /** Whether or not a 30px top margin is applied. */
  hasTopMargin: _propTypes2.default.bool,
  /** The content to be rendered. */
  htmlString: _propTypes2.default.string.isRequired,
  /** Whether or not a 15px left/right padding is applied. */
  hasHorizontalPadding: _propTypes2.default.bool
};

TextArea.displayName = 'TextArea';

exports.default = TextArea;
TextArea.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'TextArea',
  'props': {
    'hasBottomMargin': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px bottom margin is applied.'
    },
    'hasTopMargin': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px top margin is applied.'
    },
    'hasHorizontalPadding': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 15px left/right padding is applied.'
    },
    'htmlString': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'The content to be rendered.'
    }
  }
};